var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-taglist',_vm._l((_vm.items),function(i){return _c('a',{key:i,class:[
      'tag', 'is-small', 'a-tag',
      !!_vm.activeList.find(function (a) { return a === i; }) ?
        'is-primary' :
        'is-dark'
    ],on:{"click":function (v) { return _vm.$emit('toggle', i); }}},[_vm._v("\n      "+_vm._s(i)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }